export default __webpack_public_path__ + "static/media/LAS0800.34I-37497_-22105_0.a9b9a886.jpg";